module.exports = __webpack_public_path__ + "96353df1cc1db8465083453ea31ca6d7.pdf";